export { environment } from './lib/environment/environment';
export type { Environment, GriffEnvironment, MecapEnvironment } from './lib/environment/type';
export { isMecapEnvironment, isGriffEnvironment } from './lib/environment/type';
